export const DATAGRAIL_CUSTOMER_ID = '7e84c9ce-057e-4c91-87ef-56e6d4914637';

const DATAGRAIL_CONSENT_LOADER_VERSION = 'f22bb305-55b2-4ecb-a180-b85441b9a60d';

// Same-origin path served by the /api/datagrail proxy route (HP-8352), which forwards to
// api.consentjs.datagrail.io and adds the cache headers DataGrail's CDN omits.
export const DATAGRAIL_CONSENT_LOADER_SRC =
  `/api/datagrail/${DATAGRAIL_CUSTOMER_ID}/${DATAGRAIL_CONSENT_LOADER_VERSION}/consent-loader.js`;

export const DATAGRAIL_CUSTOM_STYLE_ID = 'dg-consent-custom-style';

export const DATAGRAIL_CONSENT_IDS = Object.freeze({
  BING_ADS: '7Lylth90ZOjJmYeAaw6Ufl',
  FLOODLIGHT_GOOGLE_ANALYTICS: '6jxwWOFxc79CCdmTpRKwj9',
  AD_WRAPPER_INDEX: '1GgasTGbCFBFuMMzVqFoAD',
  GOOGLE_AD_SERVICES: '7fhug8sc32a3eRySEh60JU',
  COMSCORE: '7D7U46annCfEZFbHjhl2tu',
} as const);

export type DataGrailConsentId = (typeof DATAGRAIL_CONSENT_IDS)[keyof typeof DATAGRAIL_CONSENT_IDS];
